import AssistChip from 'LuxKit/Chips/AssistChip'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { pluralizeToString } from 'lib/string/pluralize'
import React, { useCallback, useRef } from 'react'
import CalendarDurationDropdown from './CalendarDurationDropdown'
import DropdownList from 'LuxKit/Dropdown/List/DropdownList'

interface Props {
  duration: number;
  open: boolean;
  rooms?: Array<App.Occupants>;
  adultsNumber: number;
  displayPricingAsPerPerson: boolean;
  flights: boolean;
}

function CalendarDurationSelect(props: Props) {
  const { duration, open, rooms, adultsNumber, displayPricingAsPerPerson, flights } = props
  const dispatch = useOfferPageDispatch()
  const durationTriggerRef = useRef<HTMLButtonElement>(null)

  const onToggleOpen = useCallback(() => {
    dispatch({ type: OfferPageActions.toggleSubFilter, filter: 'duration' })
  }, [dispatch])

  const onClose = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
  }, [dispatch])

  return (
    <>
      <AssistChip variant="outline" size="medium" ref={durationTriggerRef} onClick={onToggleOpen}>
        {pluralizeToString('night', duration)}
      </AssistChip>
      <DropdownList
        size="M"
        open={open}
        triggerRef={durationTriggerRef}
        anchorRef={durationTriggerRef}
        title="How long do you want to stay?"
        onClose={onClose}
      >
        <CalendarDurationDropdown
          displayPricingAsPerPerson={displayPricingAsPerPerson}
          adultsNumber={adultsNumber}
          rooms={rooms}
          flights={flights}
          onClose={onClose}
        />
      </DropdownList>
    </>
  )
}

export default withOfferPageState((state) => ({
  duration: state.duration,
  open: state.activeSubFilter === 'duration',
}), CalendarDurationSelect)
